export const INTERVIEW_VISIBILITIES = [{label: 'Public', value: 'public'}, {label: 'Private', value: 'private'}];

export const INTERVIEW_VISIBILITIES_FILTERS = [{label: 'All visibilities', value: ''}, ...INTERVIEW_VISIBILITIES];
